import _ from 'lodash';
import { useSelector } from 'react-redux';
import Select from 'components/Select';
import { getProductsByCategoryId } from 'selectors/inventory';
import { getProductsOptions } from 'pages/my-stores/products/product-creator/data';

const Products = ({ CatId, value, onChange, selectedFulfillmentPant }) => {
  const allProducts = useSelector((state) => state?.products?.data);

  const products = getProductsByCategoryId(allProducts, CatId)?.filter(
    (p) =>
      !!p?.PrintProviders?.find(
        (q) => q?.ProviderName === selectedFulfillmentPant
      )
  );

  return (
    <Select
      disabled={!!!CatId}
      label="Product"
      options={getProductsOptions(products, CatId)}
      value={{ ID: value || '' }}
      valueKey="ID"
      labelKey="DisplayName"
      onChange={(ProductID) => {
        const p = getProductsByCategoryId(products, CatId);
        const product = _.find(p, (o) => o?.Product?.ID === ProductID);
        onChange(product);
      }}
    />
  );
};

export default Products;
